<template>
    <div class="row">
        <div class="col-12">
            <div class="card-header-actions">
              <div class="col-12 justify-content-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn" @click="addCategories">
                    <i v-if="loading" class="fa fa-spinner fa-spin"></i>
                    {{$t('realEstate.regression.action.addCategories')}}
                </button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false
            }
        },
        methods: {
            addCategories() {
                this.loading = true;
                this.$http.get('/uy-joy-api/categories')
                    .then(res => {
                        if (res.data.status === "SUCCESS") {
                            this.$eventBus.$emit("initSectionList")
                        }
                        this.loading = false
                    }, (err) => {
                        console.error(err);
                        this.loading = false
                    })
            }
        }
    }
</script>

<style scoped>

</style>